import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { findLocations, Screens } from 'patient-api-lib'
import { City } from '../models/types'
import { AppDispatch, RootState } from '../store'

interface CityScreenState {
  isPending: boolean
  city: City | null
  isUserLocation: boolean
}

export const initialState: CityScreenState = {
  isPending: false,
  city: null,
  isUserLocation: false,
}

export const fetchCityLocation = createAsyncThunk<
  void,
  string,
  { dispatch: AppDispatch; state: RootState }
>('cityScreen/fetchCityLocation', async (city, thunkApi) => {
  const response = await findLocations(city)
  const apiCity = response.getLocationsList()[0]
  const cities = thunkApi.getState().app.cities

  thunkApi.dispatch(
    setCity({
      name: apiCity.getName(),
      latLng: apiCity.getLatLng()?.toObject(),
      treatmentIds: cities.find((c) => c.name === apiCity.getName())
        ?.treatmentIds,
    })
  )
})

export const done = createAsyncThunk<
  Screens,
  void,
  { dispatch: AppDispatch; state: RootState }
>('cityScreen/done', async () => {
  return Screens.TreatmentScreen
})

export const CityScreenSlice = createSlice({
  name: 'cityScreen',
  initialState,
  reducers: {
    setCity: (state, action: PayloadAction<City>) => {
      state.city = action.payload
    },
    setPending: (state, action: PayloadAction<boolean>) => {
      state.isPending = action.payload
    },
    setIsUserLocation: (state, action: PayloadAction<boolean>) => {
      state.isUserLocation = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCityLocation.pending, (state) => {
      state.isPending = true
    })
    builder.addCase(fetchCityLocation.fulfilled, (state) => {
      if (state.city) {
        state.isPending = false
        state.isUserLocation = false
      }
    })
  },
})

export const { setCity, setPending, setIsUserLocation } =
  CityScreenSlice.actions

export const selectCity = (state: RootState) => state.cityScreen.city
export const isPending = (state: RootState) => state.cityScreen.isPending
export const isUserLocation = (state: RootState) =>
  state.cityScreen.isUserLocation

export default CityScreenSlice.reducer
